export const common = {
  nav: {
    ourFleet: 'Nos Locations',
    destinations: 'Destinations',
    experiences: 'Expériences',
    contact: 'Contact',
    bookNow: 'Réserver'
  },
  common: {
    backHome: 'Retour aux locations',
    backToFleet: 'Retour aux locations'
  },
  hero: {
    badge: 'Location Côte d\'Azur',
    title1: 'Explorez la',
    title2: 'French Riviera',
    description: 'Des locations de caractère pour vivre la Côte d\'Azur autrement. Bateaux, voitures iconiques, camping-cars, motos et une maison d\'exception — partez à l\'aventure à votre rythme.',
    subtitle: 'Bateaux • Voitures Iconiques • Camping-Cars • Motos • Maison',
    discover: 'Découvrir',
    catBoats: 'Bateaux',
    catBoatsDesc: 'Explorez les calanques et îles d\'or au départ d\'Hyères. Avec ou sans skipper.',
    catBoatsPrice: 'À partir de 490€/jour',
    catCars: 'Voitures',
    catCarsDesc: 'Mustang, Jeep, Porsche — des icônes pour des routes mythiques.',
    catCarsPrice: 'À partir de 190€/jour',
    catCampers: 'Camping-Cars',
    catCampersDesc: 'Liberté totale entre Provence et Méditerranée, à votre rythme.',
    catCampersPrice: 'À partir de 149€/jour',
    fullyInsured: 'Assurance Complète',
    personalService: 'Service Personnalisé',
    basedHyeres: 'Basés à Hyères, Côte d\'Azur'
  },
  boats: {
    homePort: 'Port d\'attache : Hyères',
    title: 'Nos',
    titleHighlight: 'Bateaux',
    description: 'Deux bateaux à moteur exceptionnels basés à Hyères pour votre aventure parfaite sur la Côte d\'Azur',
    upTo: 'Jusqu\'à',
    guests: 'personnes',
    passengers: 'passagers',
    berths: 'couchages',
    skipperIncluded: 'Skipper Inclus',
    avgFuel: 'Consommation moyenne',
    featuresIncluded: 'Équipements inclus',
    startingFrom: 'À partir de',
    perDay: 'par jour',
    skipperRequired: 'Skipper obligatoire',
    withOrWithout: 'Avec ou sans skipper',
    bookThisBoat: 'Réserver ce Bateau'
  },
  fleet: {
    badge: 'Nos Locations — Côte d\'Azur',
    title: 'Nos',
    titleHighlight: 'Locations',
    description: 'Bien plus que des véhicules — une sélection de caractère, choisie pour le style et les émotions qu\'elle procure. Mer, route, montagne ou villégiature : explorez la French Riviera à votre façon.',
    selectCategory: 'Cliquez sur une catégorie pour découvrir les disponibilités',
    startingFrom: 'À partir de',
    tabBoats: 'Bateaux',
    tabCars: 'Voitures',
    tabCampers: 'Camping-Cars',
    tabMotorcycles: 'Motos',
    tabHouses: 'Maison',
    tabBoatsDesc: 'Explorez les calanques et îles d\'or au départ d\'Hyères',
    tabCarsDesc: 'Mustang, Jeep, Porsche — des icônes sur les routes de la Riviera',
    tabCampersDesc: 'Liberté totale entre Provence et Méditerranée',
    tabMotorcyclesDesc: 'Harley, Ducati, BMW — la route comme terrain de jeu',
    tabHousesDesc: 'Une villa d\'exception avec piscine privée et vue mer à Hyères',
    tabBoatsPrice: 'À partir de 490€/jour',
    tabCarsPrice: 'À partir de 220€/jour',
    tabCampersPrice: 'À partir de 159€/jour',
    tabMotorcyclesPrice: 'À partir de 129€/jour',
    tabHousesPrice: 'À partir de 590€/nuit'
  },
  cars: {
    seats: 'places',
    places: 'places',
    doors: 'portes',
    fuelType: 'Carburant',
    featuresIncluded: 'Équipements inclus',
    startingFrom: 'À partir de',
    perDay: 'par jour',
    kmIncluded: 'Kilométrage inclus',
    bookThisCar: 'Réserver cette Voiture'
  },
  motorcycles: {
    seats: 'places',
    fuelType: 'Carburant',
    featuresIncluded: 'Équipements inclus',
    startingFrom: 'À partir de',
    perDay: 'par jour',
    kmIncluded: 'Kilométrage inclus',
    bookThisMotorcycle: 'Réserver cette Moto'
  },
  campers: {
    seats: 'places',
    berths: 'couchages',
    fuelType: 'Carburant',
    featuresIncluded: 'Équipements inclus',
    startingFrom: 'À partir de',
    perDay: 'par jour',
    kmIncluded: 'Kilométrage inclus',
    bookThisCamper: 'Réserver ce Camping-Car'
  },
  houses: {
    upTo: 'Jusqu\'à',
    guests: 'personnes',
    bedrooms: 'chambres',
    bathrooms: 'salles de bain',
    startingFrom: 'À partir de',
    perDay: 'par nuit',
    bookThisHouse: 'Réserver cette Maison'
  },
  destinations: {
    title: 'Votre Terrain',
    titleHighlight: 'de Jeu',
    description: 'De Hyères à Monaco, la Côte d\'Azur s\'explore en bateau, en cabriolet ou à moto. Chaque route, chaque crique est une nouvelle aventure.'
  },
  experiences: {
    title: 'Vivez',
    titleHighlight: 'l\'Aventure',
    description: 'Chaque location est une invitation à explorer la Méditerranée à votre façon — mer, route ou montagne.',
    bookThis: 'Réserver cette Expérience'
  },
  trust: {
    title: 'L\'Esprit',
    titleHighlight: 'HOPLA',
    description: 'Pas un loueur classique. Une marque lifestyle qui vous donne les clés de la Riviera.',
    fullyInsured: 'Assurance Complète',
    fullyInsuredDesc: 'Tous nos véhicules sont couverts par une assurance complète. Partez l\'esprit libre, concentrez-vous sur l\'aventure.',
    personalService: 'Expérience Personnalisée',
    personalServiceDesc: 'Nous ne sommes pas une grande chaîne. Chaque client est unique — nous adaptons chaque location à vos envies et à votre style.',
    wellMaintained: 'Véhicules de Caractère',
    wellMaintainedDesc: 'Mustang, Harley, bateaux à moteur — nos véhicules sont choisis pour leur âme, leur style et les émotions qu\'ils procurent. Méticuleusement entretenus.',
    localExpertise: 'Connaissance du Terrain',
    localExpertiseDesc: 'On connaît chaque crique, chaque col, chaque route panoramique. Nos conseils d\'initiés transforment votre séjour en véritable aventure méditerranéenne.',
    secretLocations: 'Calanques secrètes et routes panoramiques',
    bestSnorkeling: 'Meilleurs spots snorkeling et campings',
    recommendedItineraries: 'Itinéraires road trip sur mesure',
    flexibleOptions: 'Liberté Totale',
    flexibleOptionsDesc: 'Avec ou sans skipper, courte ou longue durée, mer ou route — vous choisissez votre aventure, on s\'occupe du reste.',
    skipperAvailable: 'Skipper disponible sur demande',
    halfOrFull: 'Location courte ou longue durée',
    customItineraries: 'Itinéraires personnalisés possibles',
    premiumVehicles: 'Véhicules de Caractère',
    happyGuests: 'Aventuriers Satisfaits',
    averageRating: 'Note Moyenne'
  },
  contact: {
    title: 'Réservez Votre',
    titleHighlight: 'Aventure',
    description: 'Prêt à explorer la Côte d\'Azur ? Sélectionnez votre date et heure préférées, nous confirmerons votre réservation sous 24h.',
    callUs: 'Appelez-nous',
    whatsapp: 'WhatsApp',
    email: 'Email',
    homePort: 'Port d\'attache',
    homePortValue: 'Hyères, Côte d\'Azur'
  },
  faq: {
    title: 'Questions',
    titleHighlight: 'Fréquentes',
    description: 'Tout ce que vous devez savoir avant de partir à l\'aventure sur la Côte d\'Azur',
    q1: 'Ai-je besoin d\'un permis bateau pour louer vos bateaux ?',
    a1: 'Pour CARLA (Bayliner 3055 Ciera), un permis bateau valide est requis si vous souhaitez louer sans skipper. Vous pouvez aussi choisir d\'avoir un skipper pour une expérience sans souci. Pour MAMILIPP III (Astondoa 49 GL), un skipper professionnel est toujours inclus dans la location.',
    q2: 'Qu\'est-ce qui est inclus dans le prix de location ?',
    a2: 'Nos prix incluent le véhicule, l\'assurance complète et l\'équipement de base. Pour les bateaux : carburant et matériel de snorkeling inclus. Pour les voitures et motos : kilométrage illimité. Pour les camping-cars : kit complet de voyage inclus.',
    q3: 'Quels types de locations proposez-vous ?',
    a3: 'Nous proposons 5 catégories de locations de caractère : bateaux à moteur (Bayliner et Astondoa), voitures iconiques (Mustang, Jeep, Jaguar, Range Rover, Porsche), motos d\'exception (Harley-Davidson, Ducati, BMW GS), camping-cars tout équipés et une villa d\'exception avec piscine et vue mer. Tout basé sur la Côte d\'Azur.',
    q4: 'Faut-il un permis moto spécial pour louer vos motos ?',
    a4: 'Oui, un permis A (ou A2 selon la cylindrée) en cours de validité est requis pour louer nos motos. Nos modèles Harley-Davidson Sportster S et BMW R 1250 GS nécessitent le permis A. Le Ducati Monster 937 peut être accessible avec le permis A2 selon votre expérience.',
    q5: 'Que se passe-t-il en cas de mauvais temps ?',
    a5: 'La sécurité est notre priorité. Pour les sorties en bateau, si les conditions météo sont inadaptées, nous vous contacterons pour reprogrammer sans frais supplémentaires. Les locations de voitures, motos et camping-cars ne sont généralement pas affectées par la météo.',
    q6: 'Pouvez-vous recommander un itinéraire ?',
    a6: 'C\'est notre spécialité ! En bateau : Porquerolles et Port-Cros depuis Hyères. En Mustang ou Porsche : la Corniche de l\'Esterel et Saint-Tropez. En moto : les gorges du Verdon et le col de Vence. En camping-car : la boucle Provence-Riviera. On personnalise selon vos envies !'
  },
  footer: {
    description: 'Une marque d\'aventure méditerranéenne. Bateaux, voitures iconiques, motos, camping-cars et une maison d\'exception pour explorer la French Riviera en toute liberté — basés à Hyères, Côte d\'Azur.',
    quickLinks: 'Liens Rapides',
    reviews: 'Avis',
    destinationsTitle: 'Destinations',
    contactUs: 'Nous Contacter',
    copyright: '© 2025 HOPLA FRENCH RIVIERA. Tous droits réservés.',
    ourServices: 'Nos Locations',
    boatRental: 'Location de Bateaux',
    carRental: 'Voitures Iconiques',
    camperRental: 'Camping-Cars & Liberté'
  },
  calendar: {
    stepSelectDate: 'Choisir la Date',
    stepSelectTime: 'Choisir l\'Heure',
    stepReviewSubmit: 'Confirmer',
    selectDateTitle: 'Choisissez Votre Date Préférée',
    selectTimeTitle: 'Sélectionnez un Créneau Horaire',
    reviewTitle: 'Vérifiez et Confirmez Votre Réservation',
    availableSlots: 'Créneaux disponibles',
    noSlotsAvailable: 'Aucun créneau disponible pour cette date',
    selectedDate: 'Date Sélectionnée',
    selectedTime: 'Heure Sélectionnée',
    modifyTime: 'Modifier',
    customerName: 'Votre Nom',
    customerPhone: 'Numéro de Téléphone',
    preferredBoat: 'Véhicule Préféré',
    numberOfGuests: 'Nombre de Personnes',
    specialRequests: 'Demandes Spéciales',
    back: 'Retour',
    next: 'Suivant',
    confirmBooking: 'Confirmer la Réservation',
    bookingSuccess: 'Réservation Confirmée !',
    bookingSuccessMessage: 'Nous vous contacterons sous peu pour confirmer les détails de votre location.',
    bookingError: 'Une erreur s\'est produite. Veuillez réessayer ou nous contacter directement.',
    newBooking: 'Nouvelle Réservation',
    loading: 'Chargement des dates disponibles...',
    bookingDetails: 'Détails de la Réservation',
    selectBoat: 'Sélectionnez un véhicule',
    boatCarla: 'CARLA - Bayliner 3055 Ciera (jusqu\'à 8 personnes)',
    boatMamilipp: 'MAMILIPP III - Astondoa 49 GL (jusqu\'à 12 personnes)',
    selectGuests: 'Sélectionnez le nombre de personnes',
    guests12: '1-2 personnes',
    guests34: '3-4 personnes',
    guests56: '5-6 personnes',
    guests78: '7-8 personnes',
    guests910: '9-10 personnes',
    guests1112: '11-12 personnes',
    placeholder: 'Demandes spéciales ou questions...',
    monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    dayNames: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
  },
  inspirations: {
    calanquesTitle: 'Calanques & Îles d\'Or en Bateau',
    calanquesDesc: 'Partez depuis Hyères à la découverte des calanques sauvages et des îles de Porquerolles. Nagez dans des criques cristallines inaccessibles par la route — l\'aventure commence ici.',
    sunsetTitle: 'Road Trip en Mustang sur la Corniche',
    sunsetDesc: 'Capote baissée, soleil couchant sur la Méditerranée. La Corniche de l\'Esterel en Mustang GT, c\'est l\'une des plus belles routes du monde. Une expérience qui marque à vie.',
    islandTitle: 'Grand Tour en Moto : Verdon & Riviera',
    islandDesc: 'Gorges du Verdon le matin, bord de mer l\'après-midi. En Harley ou en BMW GS, ce circuit mêle paysages alpins et côte méditerranéenne pour un road trip inoubliable.',
    fullDay: 'Journée Complète',
    evening: 'Demi-journée'
  },
  destNames: {
    calanques: 'Calanques de Marseille',
    calanquesDesc: 'Falaises calcaires et criques turquoise',
    cassis: 'Cassis',
    cassisDesc: 'Village de pêcheurs avec port coloré',
    frioul: 'Îles de Frioul',
    frioulDesc: 'Îles préservées avec plages isolées',
    saintTropez: 'Saint-Tropez',
    saintTropezDesc: 'Port glamour et plages légendaires',
    cannes: 'Cannes',
    cannesDesc: 'Célèbre Croisette et magnifique baie',
    nice: 'Nice & Villefranche',
    niceDesc: 'Eaux azur et charme Belle Époque',
    mustSee: 'Incontournable',
    popular: 'Populaire',
    hiddenGem: 'Pépite Cachée',
    iconic: 'Iconique',
    classic: 'Classique',
    beautiful: 'Magnifique'
  }
};
